<template>
	<module-field :bind="$props">
		<div slot="title" class="input-title">{{ getFieldName(field) }}</div>
		<div class="input-box">
			<selectize v-model="inputVal" :multiple="!isSingle" :settings="settings">
				<option v-if="isSingle" value="">Select {{ field.name }}</option>
				<option v-for="(tag, tagId) in options" :key="`tag-${field.id}-${tagId}`" :value="tagId" :selected="isSelected(tagId)">{{ tag }}</option>
			</selectize>
		</div>
		<div v-for="([id, name]) in (!relatedModule.can_view ? [] : selectedOptions)" :key="`details-${id}`" class="input-link">
			<a href @click.prevent="() => openModal(id)"><span class="fa fa-search-plus"></span>View {{ name }} Details</a>
		</div>
		<div v-if="relatedModule.can_view" class="input-link">
			<router-link :to="`${ relatedModule.url_path_prefix }${relatedModule.slug}`" tabindex="-1"><span class="fa fa-cog"></span>Manage {{ relatedModule.name }}</router-link>
		</div>

	</module-field>
</template>

<script>

import { mapGetters } from 'vuex';
import _ from 'underscore';
import CrudField from '@/mixins/CrudField';
import getRelationKey from '@/views/sections/app/modules/components/fields/get-relation-key';

export default {

	mixins: [CrudField],

	data() {
		return {
			// Map to id. It could have already been mapped so check it first
			inputVal: (this.value[ getRelationKey(this.field, this.value) ] || []).map(tag => tag.hasOwnProperty('id') ? (tag.id + '') : tag),
			settings: {
				valueField: 'id',
				labelField: 'name',
				searchField: ['name'],
				persist: false,
				create: false,
			},
		};
	},

	mounted() {
		this.$set(this.value, getRelationKey(this.field, this.value), this.inputVal);
	},

	computed: {

		...mapGetters(['modulesByTableName']),

		isSingle: function() {
			return this.field.config && !!this.field.config.single_select;
		},

		relatedModule: function() {
			return this.modulesByTableName[ this.field.specific_data ] || {};
		},

		selectedOptions() {
			return Object.entries(this.options).filter(([id]) => this.isSelected(id));
		},
	},

	methods: {
		isSelected(tagId) {
			if (typeof this.inputVal === 'string') {
				return this.inputVal == tagId;
			}
			return _.contains(this.inputVal, tagId);
		},

		openModal(id) {
			this.$root.$emit('open-modal', {
				type: 'detailModal',
				id,
				relatedModule: this.relatedModule,
			});
		}
	},
};
</script>
